// Global
import { useI18n } from 'next-localization';
import { useCallback } from 'react';

// Local
import { ReplacementToken, tokenReplace } from 'lib/utils/string-utils';

const useDictionary = () => {
  const i18n = useI18n();
  const getDictionaryValue = useCallback(
    (key: string, fallback?: string, tokens?: ReplacementToken[]) => {
      let returnValue;

      if (process.env.IS_STORYBOOK === 'true') {
        returnValue = fallback ?? key?.split('.')?.findLast((part) => part !== '') ?? key;
      } else {
        returnValue = i18n?.t(key) || fallback || '';
      }

      if (tokens) {
        return tokenReplace(returnValue, tokens);
      }

      return returnValue;
    },
    [i18n]
  );

  return {
    getDictionaryValue,
  };
};

export default useDictionary;
